import React from "react";
import PropTypes from "prop-types";

// auth
import { useAuthContext } from "src/auth/hooks";
import { useRefs } from "src/consuman-components/generic/context/refsContext";

import AlertDialog from "src/consuman-components/generic/alert";

const RefsComponents = React.forwardRef(({ ...props }, ref) => {
  const { user } = useAuthContext();
  const { alertDialogRef } = useRefs();

  return <>{user ? <AlertDialog ref={alertDialogRef} /> : null}</>;
});

RefsComponents.propTypes = {
  children: PropTypes.any,
  defaultOpen: PropTypes.bool,
  title: PropTypes.string,
  name: PropTypes.string,
};

export default RefsComponents;
